import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
  usePrevious,
} from "@chakra-ui/react";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/auth2.png";
import illustrationGamelight from "assets/img/auth/auth-gamelight.png";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  SignInAction,
  UpdateSignInRequestState,
} from "../../../redux/auth/action";
import { RootReducer } from "../../../RootReducer";

function SignIn() {
  const dispatch = useDispatch();
  const history = useHistory();
  const signInRequestState = useSelector(
    (state: RootReducer) => state.authentication.signInRequestState
  );
  const prevSignInRequestState = usePrevious(signInRequestState);

  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");

  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  const [mail, setMail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  useEffect(() => {
    return () => {
      dispatch(
        UpdateSignInRequestState({
          isFailed: false,
          isLoading: false,
          isSuccessful: false,
        })
      );
    };
  }, [dispatch]);

  useEffect(() => {
    if (localStorage.getItem("jwtToken")) {
      history.push("/overview");
    }
  }, [signInRequestState]);

  useEffect(() => {
    const onEnter = (e: any) => {
      if (e.key === "Enter") {
        dispatch(SignInAction(mail, password));
      }
    };

    window.addEventListener("keydown", onEnter);

    return () => {
      window.removeEventListener("keydown", onEnter);
    };
  }, [mail, password]);

  return (
    <DefaultAuth
      isSignIn={true}
      illustrationBackground={illustrationGamelight}
      image={illustration}
    >
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w="100%"
        mx={{ base: "auto", lg: "-60px" }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Login
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Enter your email and password to sign in.
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: "100%", md: "420px" }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: "auto", lg: "unset" }}
          me="auto"
          mb={{ base: "20px", md: "auto" }}
        >
          <FormControl isInvalid={signInRequestState.isFailed}>
            {signInRequestState.isFailed && (
              <FormErrorMessage style={{ marginBottom: 10 }}>
                Either mail or password is invalid.
              </FormErrorMessage>
            )}
            <Input
              isRequired={true}
              variant="auth"
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="email"
              placeholder="Email"
              value={mail}
              onChange={(c) => setMail(c.target.value)}
              mb="24px"
              fontWeight="500"
              size="lg"
            />
            <InputGroup size="md">
              <Input
                isRequired={true}
                fontSize="sm"
                placeholder="Password"
                mb="24px"
                size="lg"
                value={password}
                onChange={(c) => setPassword(c.target.value)}
                type={show ? "text" : "password"}
                variant="auth"
              />
              <InputRightElement display="flex" alignItems="center" mt="4px">
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: "pointer" }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Flex justifyContent="space-between" align="center" mb="24px">
              <FormControl display="flex" alignItems="center">
                <Checkbox
                  id="remember-login"
                  colorScheme="brandScheme"
                  me="10px"
                />
                <FormLabel
                  htmlFor="remember-login"
                  mb="0"
                  fontWeight="normal"
                  color={textColor}
                  fontSize="sm"
                >
                  Keep me logged in
                </FormLabel>
              </FormControl>
              {/*<NavLink to='/auth/forgot-password'>*/}
              {/*  <Text*/}
              {/*    color={textColorBrand}*/}
              {/*    fontSize='sm'*/}
              {/*    w='124px'*/}
              {/*    fontWeight='500'>*/}
              {/*    Forgot password?*/}
              {/*  </Text>*/}
              {/*</NavLink>*/}
            </Flex>
            <Button
              isLoading={signInRequestState.isLoading}
              onClick={() => {
                dispatch(SignInAction(mail, password));
              }}
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
            >
              Sign In
            </Button>
          </FormControl>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
